(function () {
  'use strict';

  // ---------------------------------------------------------------
  // Data bridge: window.PDP_TN_FORM_DATA is emitted by the section's
  // inline data <script>. It contains product info + Liquid-evaluated
  // server-side data that this asset JS cannot compute itself.
  // ---------------------------------------------------------------
  const DATA = (window.PDP_TN_FORM_DATA && typeof window.PDP_TN_FORM_DATA === 'object')
    ? window.PDP_TN_FORM_DATA
    : {};

  const PRODUCT_JSON_RAW = DATA.productJson || null;
  const PRODUCT_TYPE_RAW = DATA.productTypeRaw || '';
  const PRODUCT_TYPE = DATA.productType || '';
  const PRODUCT_PRICE_CENTS = typeof DATA.productPriceCents === 'number' ? DATA.productPriceCents : 0;
  const DIALOG_HEADLINE = DATA.headline || '';
  const DIALOG_SUBHEADLINE = DATA.subHeadline || '';
  const PROPERTIES_JSON = DATA.propertiesJson || '';
  // Produkt-Metafeld custom.first_session_lead_magnet == 'Ja' (Liquid-seitig ausgewertet).
  const FIRST_SESSION_LEAD_MAGNET = DATA.firstSessionLeadMagnet === true;

  // Preprocessed productData (id, type, title, handle, price, variants, options,
  // sessionTimes, reportVariant) — already filtered by Liquid for the relevant types.
  const PRODUCT_DATA_BASE = DATA.productData || null;

  // Legacy global kept for any external integrations that read it.
  if (PRODUCT_JSON_RAW) {
    window.pdpTnFormProduct = PRODUCT_JSON_RAW;
  }

  // ---------------------------------------------------------------
  // Select Fields + Option Generation
  // ---------------------------------------------------------------

  document.addEventListener('DOMContentLoaded', function () {
    if (!PRODUCT_DATA_BASE) return;

    let productData = JSON.parse(JSON.stringify(PRODUCT_DATA_BASE));

    productData.variants = productData.variants.filter((variant) => variant.available);

    productData.variants.forEach((variant) => {
      let option1 = variant.option1;
      let option2 = variant.option2;

      if (option1) {
        if (option1.includes('Ohne Report')) {
          option1 = option2;
          variant.option1 = option1;
          variant.option2 = '';
        }
      }

      if (option2) {
        if (option2.includes('Ohne Report')) {
          variant.option2 = null;
        }
      }
    });

    productData.options = productData.options.filter((option) => !option.includes('Report'));

    productData.variants = productData.variants.filter((variant) => {
      const isAvailable = variant.available;
      const hasMitReport = variant.option1 === 'Mit Report' || variant.option2 === 'Mit Report';
      return isAvailable && !hasMitReport;
    });

    if (productData.variants.length === 1 && productData.options.length === 0) {
      productData.options.push('Flexible Start Date');
      productData.variants[0].option1 = 'Default Title';
    }

    if (productData.variants.length > 0) {
      const processedVariants = processSellableVariants(productData);
      createProductOptions(processedVariants);

      const formElement = document.querySelector('.TN-Form');
      if (!formElement) return;
      const variantId = formElement.getAttribute('data-additionalproductvariantid');
      const isAvailable = formElement.getAttribute('data-availability');

      if (variantId && isAvailable === 'true') {
        const event = new CustomEvent('additionalProductFound');
        window.dispatchEvent(event);
      }
    } else {
      const formContentElement = document.querySelector('.TN-Form-Content');
      if (!formContentElement) return;
      const headlineWrapperElement = formContentElement.querySelector('.TN-Form-Headline-Wrapper');
      // Strukturelle Selektoren statt Typo-Klassen: die alten text-*-Klassen
      // existieren in der Box nicht mehr (txt-*-Migration). Der frühere
      // subHeadline-Selektor ('text-body-m', ohne Punkt) hat nie gematcht.
      const headline = headlineWrapperElement ? headlineWrapperElement.querySelector('p') : null;
      const subHeadline = formContentElement.querySelector('.TN-Form-CTA-Top > p');

      if (headline) headline.innerText = 'Ausverkauft';
      if (subHeadline) {
        subHeadline.innerText = 'Trage dich hier ein, um eine Benachrichtigung zu erhalten, sobald die nächsten Termine feststehen.';
      }

      const formElement = document.querySelector('.TN-Form');
      if (formElement) {
        // Build the "Benachrichtigen" mount from preserved legacy markup.
        // NOTE: The HTML below mirrors the original inline implementation so the
        // Subscribe-It integration continues to read the product JSON from the
        // .SI_trigger attribute. The element is kept in the DOM as an invisible
        // mount only — Subscribe-It renders its own visible notify button ("Gib
        // mir Bescheid", and respects the notify-it-hidden tag). Rendering this
        // legacy anchor as a second visible button produced two overlapping CTAs
        // in the sold-out state, so it is visually hidden (not removed).
        const bisElement = document.createElement('div');
        bisElement.style.cssText =
          'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;padding:0;margin:-1px;';
        const anchor = document.createElement('a');
        anchor.setAttribute('href', '#');
        anchor.className = 'SI_trigger';
        anchor.setAttribute('data-product-data', JSON.stringify(PRODUCT_JSON_RAW || ''));
        anchor.textContent = 'Benachrichtigung erhalten';
        bisElement.appendChild(anchor);
        formElement.appendChild(bisElement);
      }
    }

    // eslint-disable-next-line no-unused-vars
    let dialogHeadline = DIALOG_HEADLINE;
    // eslint-disable-next-line no-unused-vars
    let dialogSubHeadline = DIALOG_SUBHEADLINE;
    // eslint-disable-next-line no-unused-vars
    let dialogProductType = PRODUCT_TYPE;
    // eslint-disable-next-line no-unused-vars
    let productJsonData = '';

    // eslint-disable-next-line no-unused-vars
    let productsInCart = [];
    productsInCart.push(PROPERTIES_JSON);
  });

  function processSellableVariants(productData) {
    productData.options.forEach((option, index) => {
      productData.options[index] = {
        type: option,
        values: [],
      };

      productData.variants.forEach((variant) => {
        const optionName = `option${index + 1}`;
        const optionValue = variant[optionName];

        if (optionValue && !productData.options[index].values.includes(optionValue)) {
          productData.options[index].values.push(optionValue);
        }

        variant.product_id = productData.id;
        variant.product_type = productData.type;
      });
    });

    return productData;
  }

  function buildOptionField(optionType, styleProperty, jsGen) {
    const container = document.createElement('div');
    container.className = 'TN-Form-Input-Container';
    if (styleProperty) container.setAttribute('style', 'display: none');

    const labelWrapper = document.createElement('div');
    labelWrapper.className = 'TN-Form-Label-Wrapper';
    const label = document.createElement('label');
    label.className = 'TN-Form-Label text-label-m';
    label.textContent = optionType.type;
    labelWrapper.appendChild(label);
    container.appendChild(labelWrapper);

    const selectWrapper = document.createElement('div');
    selectWrapper.className = 'TN-Form-Select-Wrapper';

    if (optionType.values.length === 1) {
      const field = document.createElement('div');
      field.className = 'TN-Form-Select-Field';
      field.setAttribute('data-autogen', 'true');
      field.textContent = optionType.values[0];
      selectWrapper.appendChild(field);
    } else {
      const select = document.createElement('select');
      select.className = 'TN-Form-Select-Field';
      select.setAttribute('data-autogen', 'true');
      select.setAttribute('name', optionType.type);
      optionType.values.forEach((value) => {
        const opt = document.createElement('option');
        opt.textContent = value;
        select.appendChild(opt);
      });
      selectWrapper.appendChild(select);
    }

    container.appendChild(selectWrapper);
    return container;
  }

  function buildSingleVariantField(product, styleProperty) {
    const container = document.createElement('div');
    container.className = 'TN-Form-Input-Container';
    if (styleProperty) container.setAttribute('style', 'display: none');

    const labelWrapper = document.createElement('div');
    labelWrapper.className = 'TN-Form-Label-Wrapper';
    const label = document.createElement('label');
    label.className = 'TN-Form-Label text-label-m';
    label.textContent = product.options[0].type;
    labelWrapper.appendChild(label);
    container.appendChild(labelWrapper);

    const selectWrapper = document.createElement('div');
    selectWrapper.className = 'TN-Form-Select-Wrapper';
    const field = document.createElement('div');
    field.className = 'TN-Form-Select-Field';
    field.setAttribute('data-autogen', 'true');
    field.textContent = product.variants[0].option1;
    selectWrapper.appendChild(field);
    container.appendChild(selectWrapper);
    return container;
  }

  function buildReportInfoWrapper() {
    const wrapper = document.createElement('div');
    wrapper.className = 'TN-Form-Info-Wrapper';
    wrapper.style.fontFamily = 'var(--main-font)';

    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('xmlns', NS);
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '21');
    svg.setAttribute('viewBox', '0 0 20 21');
    svg.setAttribute('fill', 'none');
    svg.style.fontFamily = 'var(--main-font)';

    const path = document.createElementNS(NS, 'path');
    path.setAttribute(
      'd',
      'M9.16669 8.00033H10.8334V6.33366H9.16669V8.00033ZM10 17.167C6.32502 17.167 3.33335 14.1753 3.33335 10.5003C3.33335 6.82533 6.32502 3.83366 10 3.83366C13.675 3.83366 16.6667 6.82533 16.6667 10.5003C16.6667 14.1753 13.675 17.167 10 17.167ZM10 2.16699C8.90567 2.16699 7.82204 2.38254 6.81099 2.80133C5.79994 3.22012 4.88129 3.83395 4.10746 4.60777C2.54466 6.17057 1.66669 8.29019 1.66669 10.5003C1.66669 12.7105 2.54466 14.8301 4.10746 16.3929C4.88129 17.1667 5.79994 17.7805 6.81099 18.1993C7.82204 18.6181 8.90567 18.8337 10 18.8337C12.2102 18.8337 14.3298 17.9557 15.8926 16.3929C17.4554 14.8301 18.3334 12.7105 18.3334 10.5003C18.3334 9.40598 18.1178 8.32234 17.699 7.3113C17.2802 6.30025 16.6664 5.38159 15.8926 4.60777C15.1188 3.83395 14.2001 3.22012 13.189 2.80133C12.178 2.38254 11.0944 2.16699 10 2.16699ZM9.16669 14.667H10.8334V9.66699H9.16669V14.667Z'
    );
    path.setAttribute('fill', '#3B3D43');
    path.style.fontFamily = 'var(--main-font)';
    svg.appendChild(path);

    const p = document.createElement('p');
    p.id = 'TN-Form-Report-Dialog-Open';
    p.className = 'text-body-s';
    p.style.fontFamily = 'var(--main-font)';
    p.textContent = 'Mehr zum OMR Report';

    wrapper.appendChild(svg);
    wrapper.appendChild(p);
    return wrapper;
  }

  function createProductOptions(productData) {
    let sessionTimes = productData.sessionTimes;
    const optionsContainer = document.querySelector('.TN-Form');
    if (!optionsContainer) return;

    optionsContainer.setAttribute('data-product', JSON.stringify(productData));
    optionsContainer.setAttribute('data-type', productData.type);
    optionsContainer.setAttribute('data-title', productData.title);

    if (sessionTimes) {
      optionsContainer.setAttribute('data-times', JSON.stringify(sessionTimes));
    }

    const productType = productData.type;
    const productPrice = PRODUCT_PRICE_CENTS;

    let styleProperty = '';
    if (
      productData.variants[0].option1 === 'Default Title' ||
      productData.variants[0].title === 'Default Title'
    ) {
      styleProperty = 'display: none';
    }

    if (productData.variants.length === 1) {
      optionsContainer.appendChild(buildSingleVariantField(productData, styleProperty));
    } else {
      productData.options.forEach((optionType) => {
        optionsContainer.appendChild(buildOptionField(optionType, styleProperty));
      });
    }

    let containsReport = false;
    productData.options.forEach((option) => {
      option.values.forEach((value) => {
        if (value.toLowerCase().includes('report')) {
          containsReport = true;
        }
      });
    });

    if (containsReport) {
      optionsContainer.appendChild(buildReportInfoWrapper());
    }

    const hasReportOption = document.querySelector('.TN-Form-Info-Wrapper');
    const hasVariantInUrl = getVariantIdFromUrl();

    if (hasVariantInUrl) {
      changeInputValuesByUrlParam();
    }

    if (hasReportOption) {
      const reportOption = new CustomEvent('reportOptionAvailable');
      document.dispatchEvent(reportOption);
    }

    if (hasReportOption && !hasVariantInUrl) {
      changeInputValueReportBundle('');
    }

    const selectFields = document.querySelectorAll('.TN-Form-Select-Field');

    selectFields.forEach((field) => {
      field.addEventListener('change', () => {
        let rightVariant = findTheRightVariant(productData);
        setVariantProperties(rightVariant);
        handleSessionVisibility(rightVariant.id);
      });
    });

    const addToCartBtn = document.createElement('button');
    addToCartBtn.classList.add('TN-Form-addToCart');
    addToCartBtn.innerText = 'Jetzt anmelden';
    addToCartBtn.addEventListener('click', () => {
      triggerDialog();
    });

    optionsContainer.appendChild(addToCartBtn);

    const formComponentsEvent = new CustomEvent('SetupDialog');
    document.dispatchEvent(formComponentsEvent);

    if (productType === 'OMR Academy' || productType === 'OMR Academy Kompakt') {
      const demoCampusButton = document.createElement('a');
      demoCampusButton.className =
        'pCampus__Btn__Wrapper omr-button-secondary-medium omr-button-secondary--neutral';
      demoCampusButton.id = 'TN-Form-Button-Demo-Campus';
      demoCampusButton.style.borderRadius = 'var(--button-corner, 2px)';
      demoCampusButton.style.border = '2px solid var(--button-black-enabled, #141314)';
      demoCampusButton.onclick = triggerModal;
      demoCampusButton.textContent = 'Demo-Campus entdecken';
      optionsContainer.appendChild(demoCampusButton);
    }

    if (productType === 'OMR Digital Marketing School' && productPrice != 19900) {
      const demoCampusButton = document.createElement('a');
      demoCampusButton.className =
        'pCampus__Btn__Wrapper omr-button-secondary-medium omr-button-secondary--neutral';
      demoCampusButton.id = 'TN-Form-Button-Demo-Campus';
      demoCampusButton.style.borderRadius = 'var(--button-corner, 2px)';
      demoCampusButton.style.border = '2px solid var(--button-black-enabled, #141314)';
      demoCampusButton.href =
        'https://education.omr.com/products/odms-digital-marketing-school-komplettpaket-inkl-zertifikat-und-aufzeichnungen';
      demoCampusButton.textContent = 'Komplettpaket sichern & sparen';
      optionsContainer.appendChild(demoCampusButton);
    }


    if (FIRST_SESSION_LEAD_MAGNET) {
      optionsContainer.appendChild(buildFirstSessionButton('TN-Form-firstSession--box'));

      // Zweiter Button im Hero-CTA-Block; CSS blendet je Breakpoint einen
      // der beiden ein (Box ab 1024px, Hero darunter).
      const heroSection = optionsContainer.closest('.shopify-section') || document;
      const heroButtonBox = heroSection.querySelector('.Pdp-Header-Button-Box');
      if (heroButtonBox) {
        const heroFirstSessionButton = buildFirstSessionButton('TN-Form-firstSession--hero');
        const heroPrimaryCta = heroButtonBox.querySelector('#Pdp-Header-Cta');
        if (heroPrimaryCta) {
          heroPrimaryCta.insertAdjacentElement('afterend', heroFirstSessionButton);
        } else {
          heroButtonBox.appendChild(heroFirstSessionButton);
        }

        // Bis 767px wandert der Merkliste-Button neben die Startdaten-Badges,
        // darueber zurueck in den CTA-Block.
        const mobileBadges = heroSection.querySelector('.pdp-mobile-badges');
        const wishlistButton = heroButtonBox.querySelector('.wishlist-button');
        if (mobileBadges && wishlistButton) {
          const wishlistHome = wishlistButton.parentElement;
          const mobileQuery = window.matchMedia('(max-width: 767px)');

          const placeWishlistButton = function (isMobile) {
            if (isMobile) {
              mobileBadges.classList.add('pdp-mobile-badges--with-wishlist');
              mobileBadges.appendChild(wishlistButton);
            } else {
              mobileBadges.classList.remove('pdp-mobile-badges--with-wishlist');
              wishlistHome.appendChild(wishlistButton);
            }
          };

          placeWishlistButton(mobileQuery.matches);
          mobileQuery.addEventListener('change', function (event) {
            placeWishlistButton(event.matches);
          });
        }
      }
    }



    if (productType === 'Creative Strategy Diploma' || productType === 'CSD') {
      const demoCampusButtonCSD = document.createElement('a');
      demoCampusButtonCSD.className =
        'pCampus__Btn__Wrapper omr-button-secondary-medium omr-button-secondary--neutral';
      demoCampusButtonCSD.id = 'TN-Form-Button-Demo-Campus';
      demoCampusButtonCSD.style.borderRadius = 'var(--button-corner, 2px)';
      demoCampusButtonCSD.style.border = '2px solid var(--button-black-enabled, #141314)';
      demoCampusButtonCSD.onclick = triggerModalCSD;
      demoCampusButtonCSD.textContent = 'Demo-Campus entdecken';
      optionsContainer.appendChild(demoCampusButtonCSD);
    }

    let firstVariant = findTheRightVariant(productData);
    setVariantProperties(firstVariant);
    handleSessionVisibility(firstVariant.id);
  }

  function findTheRightVariant(productData) {
    const selectFields = document.querySelectorAll('.TN-Form-Select-Field[data-autogen="true"]');
    const fieldCount = selectFields.length;

    let values = [];
    let rightVariant;

    selectFields.forEach((field) => {
      if (field.tagName === 'DIV') {
        values.push(field.textContent);
      } else {
        values.push(field.value);
      }
    });

    productData.variants.forEach((variant) => {
      if (fieldCount === 1 && values[0] === variant.option1) {
        rightVariant = variant;
      }
      if (fieldCount === 2 && values[0] === variant.option1 && values[1] === variant.option2) {
        rightVariant = variant;
      }
      if (
        fieldCount === 3 &&
        values[0] === variant.option1 &&
        values[1] === variant.option2 &&
        values[2] === variant.option3
      ) {
        rightVariant = variant;
      }
    });

    setVariantPrice(rightVariant);
    updateVariantIdInUrl(rightVariant.id);

    return rightVariant;
  }

  function setVariantPrice(variant) {
    let mainFormElement = document.querySelector('.TN-Form');
    if (!mainFormElement) return;
    mainFormElement.setAttribute('data-currentvariantprice', variant.price);
    mainFormElement.setAttribute('data-currentvariantcompareprice', variant.compare_at_price);

    let mainProductSelectField = document.querySelector('.TN-Form-Select-Field[data-autogen="true"]');
    let additionalProductSelectField = document.getElementById('additionalProductSelect');
    if (additionalProductSelectField) {
      if (typeof updateVariantPrice === 'function') {
        updateVariantPrice(additionalProductSelectField.selectedOptions[0]);
      }
    } else {
      if (typeof updateVariantPrice === 'function') {
        updateVariantPrice(mainProductSelectField);
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  function formatNumber(num, options = { minimumFractionDigits: 0, maximumFractionDigits: 0 }) {
    return num.toLocaleString('de-DE', options);
  }

  function setVariantProperties(variant) {
    const price = variant.price;
    const comparePrice = variant.compare_at_price;
    const variantId = variant.id;
    const productId = variant.product_id;
    const sku = variant.sku;

    const btn = document.querySelector('.TN-Form-addToCart');
    if (btn) {
      btn.setAttribute('data-price', price);
      btn.setAttribute('data-compare', comparePrice);
      btn.setAttribute('data-variantid', variantId);
      btn.setAttribute('data-productid', productId);
      btn.setAttribute('data-sku', sku);
    } else {
      console.error('Button with class .addToCartBtn not found!');
    }
  }

  function updateVariantIdInUrl(variantId) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set('variant', variantId);
    url.search = params.toString();
    window.history.replaceState(null, '', url.toString());
  }

  function openModuleCard(card) {
    console.log('openModuleCard called');
    console.log(card, 'card');
    const moduleCardHiddenContent = card.querySelector('.Pdp-Modules-Card-Hidden');
    const moduleCardContent = card.querySelector('.Pdp-Modules-Card-Content');
    const chevron = card.querySelector('.Pdp-Modules-Card-Button-Chevron');

    if (!moduleCardHiddenContent || !moduleCardContent || !chevron) return;

    moduleCardHiddenContent.style.maxHeight = 'none';
    const scrollHeight = moduleCardHiddenContent.scrollHeight;

    moduleCardHiddenContent.style.maxHeight = scrollHeight + 'px';
    moduleCardHiddenContent.classList.add('open');

    if (window.innerWidth >= 320 && window.innerWidth <= 767) {
      moduleCardContent.style.paddingBottom = '16px';
      moduleCardContent.style.borderBottom = '#585A62 solid 1px';
      card.style.gap = '16px';
    } else {
      moduleCardContent.style.paddingBottom = '24px';
      moduleCardContent.style.borderBottom = '#585A62 solid 1px';
      card.style.gap = '24px';
    }
    chevron.style.transform = 'rotate(180deg)';
  }

  function handleSessionVisibility(variantId) {
    console.log('show this variant ' + variantId);

    let contentSections = document.querySelectorAll('.Pdp-Modules-Container');
    contentSections.forEach((section) => {
      let sectionVariantId = section.getAttribute('data-variantid');

      if (variantId === parseInt(sectionVariantId)) {
        section.style.display = '';
        setTimeout(() => {
          const card = section.querySelector('.Pdp-Modules-Card');
          if (card) {
            openModuleCard(card);
          }
        }, 100);
      } else {
        console.log('hide section', section);
        section.style.display = 'none';
      }
    });
  }

  // eslint-disable-next-line no-unused-vars
  function updateSessionTimes(variantId) {
    const form = document.querySelector('.TN-Form');
    if (!form) return;
    let sessionTimes = JSON.parse(form.getAttribute('data-times'));

    for (let i = 0; i < sessionTimes.length; i++) {
      if (sessionTimes[i].id === variantId) {
        let dateWrappers = document.querySelectorAll('.Pdp-Modules-Card-Date-Wrapper');
        let timeWrappers = document.querySelectorAll('.Pdp-Modules-Card-Time-Wrapper');

        for (let j = 0; j < dateWrappers.length; j++) {
          let sessionDateParagraph = dateWrappers[j].querySelector('p');
          let sessionDate = sessionTimes[i].times[j].session;
          let sessionDateParts = sessionDate.split(' | ')[0];
          let sessionDateLastPart = sessionDateParts.split('. ').slice(-1)[0];
          sessionDateParagraph.textContent = sessionDateLastPart;

          let sessionTimeParagraph = timeWrappers[j].querySelector('p');
          let sessionTime = sessionTimes[i].times[j].session.split(' | ').slice(-1)[0];
          sessionTimeParagraph.textContent = sessionTime;
        }
        break;
      }
    }
  }

  function changeInputValuesByUrlParam() {
    let variantId = parseInt(getVariantIdFromUrl());

    if (variantId) {
      const form = document.querySelector('.TN-Form');
      if (!form) return;
      const productData = JSON.parse(form.getAttribute('data-product'));
      let options = [];

      if (Array.isArray(productData.variants)) {
        productData.variants.forEach((variant) => {
          if (variantId === variant.id) {
            if (variant.option1) options.push(variant.option1);
            if (variant.option2) options.push(variant.option2);
            if (variant.option3) options.push(variant.option3);
          }
        });
      }

      if (options.length > 0) {
        const selectFields = document.querySelectorAll('.TN-Form-Select-Field');
        for (let i = 0; i < selectFields.length; i++) {
          selectFields[i].value = options[i];
        }
        selectFields[0].dispatchEvent(new Event('change'));
      }
    }
  }

  function getVariantIdFromUrl() {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const variantId = url.searchParams.get('variant');
    return variantId;
  }

  function triggerDialog() {
    const buttonElement = document.querySelector('.TN-Form-addToCart');
    if (!buttonElement) return;
    const sku = buttonElement.getAttribute('data-sku');
    const variantId = buttonElement.getAttribute('data-variantid');
    const productId = buttonElement.getAttribute('data-productid');

    const participantStore = document.getElementById('participantData__DataStore');
    const cartProperties = participantStore ? participantStore.getAttribute('data-cart') : '';

    let additionalProductVariantId =
      typeof getAdditionalProductVariantId === 'function' ? getAdditionalProductVariantId() : null;
    let additionalProductQuantity;
    let additionalProductsArray = [];

    if (additionalProductVariantId) {
      additionalProductQuantity = 1;
      additionalProductsArray.push({
        id: additionalProductVariantId,
        quantity: additionalProductQuantity,
      });
    }

    const subHeadline = DIALOG_SUBHEADLINE;
    let dialogSettings = {
      source: 'product',
      action: 'open',
      variantId: variantId,
      productId: productId,
      quantity: 1,
      sku: sku,
      fastselectdata: cartProperties,
      headline: DIALOG_HEADLINE,
      subHeadline: subHeadline,
      productType: PRODUCT_TYPE_RAW,
      additionalproductvariantids: additionalProductVariantId,
      additionalproductquantities: additionalProductQuantity,
      additionalproductarray: JSON.stringify(additionalProductsArray),
    };
    if (typeof openCloseDialog === 'function') {
      openCloseDialog(dialogSettings);
    }
  }

  // ---------------------------------------------------------------
  // Report Bundle Dialog
  // ---------------------------------------------------------------

  document.addEventListener('reportOptionAvailable', () => {
    const reportPdpDialog = document.querySelector('.Pdp-Report-Dialog');
    const reportDialogShowButton = document.getElementById('TN-Form-Report-Dialog-Open');
    const reportAcceptOptionButton = document.querySelectorAll('.Pdp-Report-Dialog-CTA');
    const reportDialogCloseButton = document.querySelector('.Pdp-Report-Dialog-Close-Button');

    if (!reportPdpDialog || !reportDialogShowButton || !reportDialogCloseButton) return;

    reportAcceptOptionButton.forEach((button) => {
      button.addEventListener('click', () => {
        reportPdpDialog.close();
      });
    });

    reportDialogShowButton.addEventListener('click', () => {
      if (typeof pushEventToDataLayer === 'function') {
        pushEventToDataLayer('reportOptionModalOpened', '', window.location.href, '');
      }
      reportPdpDialog.showModal();
    });

    reportDialogCloseButton.addEventListener('click', () => {
      reportPdpDialog.close();
    });

    reportPdpDialog.addEventListener('click', (e) => {
      const reportPdpDialogDimensions = reportPdpDialog.getBoundingClientRect();
      if (
        e.clientX < reportPdpDialogDimensions.left ||
        e.clientX > reportPdpDialogDimensions.right ||
        e.clientY < reportPdpDialogDimensions.top ||
        e.clientY > reportPdpDialogDimensions.bottom
      ) {
        reportPdpDialog.close();
      }
    });
  });

  function changeInputValueReportBundle(element) {
    if (typeof pushEventToDataLayer === 'function') {
      pushEventToDataLayer('reportOptionSelected', '', window.location.href, '');
    }

    const selectElement = document.getElementById('additionalProductSelect');
    if (!selectElement) return;

    if (element) {
      let variantId = element.getAttribute('data-matchingid');
      console.log(variantId);
      console.log(element);

      const optionToSelect = Array.from(selectElement.options).find(
        (option) => option.dataset.variantid === variantId
      );
      if (optionToSelect) {
        selectElement.value = optionToSelect.value;
        selectElement.dispatchEvent(new Event('change'));
      }
    } else {
      const optionToSelect = Array.from(selectElement.options).find((option) => option.dataset.action === 'add');
      if (optionToSelect) {
        selectElement.value = optionToSelect.value;
        selectElement.dispatchEvent(new Event('change'));
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  function checkIfProductHasLiveVariants(productData) {
    let isSellable = false;

    productData.variants.forEach((variant) => {
      if (variant.available) {
        isSellable = true;
      }
    });

    return isSellable;
  }

  // ---------------------------------------------------------------
  // DIALOG Functions
  // ---------------------------------------------------------------

  function hasNoVisibleOptions() {
    const variantContainers = document.querySelectorAll('.TN-Form .TN-Form-Input-Container');
    let hasVisibleVariantOptions = false;

    variantContainers.forEach((container) => {
      if (container.style.display !== 'none') {
        hasVisibleVariantOptions = true;
      }
    });

    const hasAdditionalProduct = document.getElementById('additionalProductSelect') !== null;
    return !hasVisibleVariantOptions && !hasAdditionalProduct;
  }

  function setupDialog(showButtonId, closeButtonId, dialogId, ctaButtonId) {
    const dialogShowButton = document.getElementById(showButtonId);
    const dialogCloseButton = document.getElementById(closeButtonId);
    const dialogCtaButton = document.querySelector(ctaButtonId);
    const dialogElement = document.getElementById(dialogId);
    const pdpHeaderMobileCta = document.getElementById('Pdp-Header-Cta');
    const demoCampusButton = document.getElementById('TN-Form-Button-Demo-Campus');

    if (!dialogElement || !dialogShowButton || !dialogCloseButton || !dialogCtaButton) return;

    dialogElement.addEventListener('click', (e) => {
      const dialogDimensions = dialogElement.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        dialogElement.close();
      }
    });

    dialogShowButton.addEventListener('click', () => {
      if (closeButtonId == 'TN-Form-Dialog-Close-Button') {
        const fb = document.getElementById('TN-Floatingbar');
        if (fb) fb.style.display = 'none';
      }
      // Ohne buchbare Optionen führt der CTA direkt in den Teilnehmer-Dialog,
      // sonst in die TN-Box.
      if (hasNoVisibleOptions()) {
        triggerDialog();
      } else {
        dialogElement.showModal();
      }
    });

    dialogCloseButton.addEventListener('click', () => {
      dialogElement.close();
    });

    dialogCtaButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.innerWidth <= 1023) {
        dialogElement.close();
      }
    });

    if (demoCampusButton) {
      demoCampusButton.addEventListener('click', () => {
        if (window.innerWidth <= 1023) {
          dialogElement.close();
        }
      });
    }

    dialogElement.addEventListener('close', () => {
      const fb = document.getElementById('TN-Floatingbar');
      if (window.innerWidth <= 1023 && fb && window.getComputedStyle(fb).display == 'none') {
        fb.style.display = 'flex';
      }
    });

    if (window.innerWidth > 1023) {
      dialogElement.show();
    } else {
      dialogElement.close();
    }

    if (window.innerWidth <= 1023) {
      if (pdpHeaderMobileCta) {
        pdpHeaderMobileCta.addEventListener('click', () => {
          if (hasNoVisibleOptions()) {
            triggerDialog();
          } else {
            dialogElement.showModal();
          }
        });
      }
    }
  }

  document.addEventListener('SetupDialog', () => {
    setupDialog('TN-Floatingbar-Button', 'TN-Form-Dialog-Close-Button', 'TN-Form-Dialog', '.TN-Form-addToCart');
  });

  // ---------------------------------------------------------------
  // Modal / Form Code (Democampus)
  // ---------------------------------------------------------------

  function buildDemoCampusFields(utmContent) {
    return [
      {
        fields: [
          {
            row: [
              {
                type: 'text',
                urlparamname: 'firstname',
                label: 'Vorname',
                placeholder: 'Dein Vorname',
                error: 'Bitte trage deinen Vornamen ein',
                required: 'true',
              },
              {
                type: 'email',
                urlparamname: 'email',
                label: 'E-Mail',
                placeholder: 'Deine E-Mail',
                error: 'Bitte trage deine E-Mail ein',
                required: 'true',
              },
            ],
          },
                         {
                'row': [
                    {
                        type: 'text',
                        urlparamname: 'phone',
                        label: 'Telefonnummer (optional)',
                        placeholder: 'Nur wenn du möchtest. Kein Abo, kein Spam, keine weiteren Anrufe.',
                        error: 'Bitte trage deine Telefonnummer ein',
                        required:'false'
                    }
                ]
            },
          {
            row: [
              {
                type: 'math',
                label: 'Validierung',
                urlparamname: 'math',
                placeholder: 'Bitte löse diese Matheaufgabe',
                error: 'Bitte zeige uns, dass du kein Bot bist und löse diese Matheaufgabe',
                required: 'true',
              },
            ],
          },
        ],
        headlines: { headline: 'Jetzt eintragen', subheadline: 'Und sofort Zugang zum Demo-Campus erhalten' },
        agb: { text: 'Mit dem Absenden stimmst du unserer Datenschutzerklärung zu.' },
        button: { text: 'Absenden' },
        success: {
          icon: '✔️',
          message:
            'Danke für dein Interesse am Democampus. Solltest du noch kein Subscriber sein, bestätige bitte die E-Mail, die wir dir gerade an deine E-Mail Adresse geschickt haben.<br><br>Deinen Campus-Zugang erhältst du in einer separaten Mail von uns. Schau am besten auch in deinen Spam-Ordner.',
          filedownoad: '',
          buttontext: '',
          url: '',
        },
        tracking: {
          webhook: 'https://hooks.zapier.com/hooks/catch/590116/3wrzncq/',
          additionalparams: [
            { key: 'list', value: 'OMR_Education' },
            { key: 'utm_content', value: utmContent },
            {
              key: 'doimessage',
              value:
                'Die Anmeldung zum Demo-Campus war erfolgreich! Die Mail mit deinem persönlichen Zugangslink ist auch schon auf dem Weg zu dir. Bitte bestätige über den Klick auf den Button, dass wir dir E-Mails senden dürfen. Danach nehmen wir dich in unseren Newsletter-Verteiler auf. Natürlich kannst du dich jederzeit wieder von unserem Newsletter abmelden.',
            },
          ],
        },
        background: {
          desktopleft: '',
          desktopright: '',
          laptopleft: '',
          laptopright: '',
          tabletleft: '',
          tabletright: '',
          mobileleft: '',
          mobileright: '',
        },
        color: '',
      },
    ];
  }

  function triggerModal() {
    const demoCampusFormModifier = 'demoCampusModalForm';
    const demoCampusFormFields = buildDemoCampusFields('probecampus-form');
    if (typeof openModal === 'function') {
      openModal(
        'createForm',
        'contactform-wrapper',
        'contactform-wrapper-demoCampusModalForm',
        demoCampusFormModifier,
        demoCampusFormFields
      );
    }
  }

  function triggerModalCSD() {
    const demoCampusFormModifier = 'demoCampusModalForm';
    const demoCampusFormFields = buildDemoCampusFields('csd-probecampus-form');
    if (typeof openModal === 'function') {
      openModal(
        'createForm',
        'contactform-wrapper',
        'contactform-wrapper-demoCampusModalForm',
        demoCampusFormModifier,
        demoCampusFormFields
      );
    }
  }




function buildFirstSessionButton(modifierClass) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className =
    'TN-Form-firstSession ' + modifierClass + ' omr-button-secondary-medium omr-button-secondary--neutral';
  button.textContent = 'Zur ersten Session gratis anmelden';
  button.addEventListener('click', triggerFirstSessionModal);
  return button;
}

function triggerFirstSessionModal(){

  // Der Lead-Magnet haengt fest an der ersten Variante: erster gerenderter
  // Modul-Block, unabhaengig davon welche Variante gerade gewaehlt ist.
  const firstModulesSection = document.querySelector(".Pdp-Modules-Container");
  const firstSession = firstModulesSection
    ? firstModulesSection.querySelector(".Pdp-Modules-Card")
    : null;
  if (!firstSession) return;

  const headlineEl =
    firstSession.querySelector(".Pdp-Modules-Card-Title-Wrapper h3") ||
    firstSession.querySelector(".text-headline-xs-desktop");
  const dateEl = firstSession.querySelector(".Pdp-Modules-Card-Date-Wrapper p");
  const timeEl = firstSession.querySelector(".Pdp-Modules-Card-Time-Wrapper p");
  if (!headlineEl || !dateEl || !timeEl) return;

  const firstSessionHeadline = headlineEl.innerText;
  const firstSessionDate = dateEl.innerText;
  const firstSessionTime = timeEl.innerText;

  const firstVariantId = parseInt(firstModulesSection.getAttribute("data-variantid"), 10);
  const productVariants = (PRODUCT_JSON_RAW && PRODUCT_JSON_RAW.variants) || [];
  const firstVariant = productVariants.filter(function (variant) {
    return variant.id === firstVariantId;
  })[0];

  // SKU-Format: "omrdd_id1|id2:dauer1|dauer2" - erste Session = jeweils Index 0.
  const sku = (firstVariant && firstVariant.sku) || "";
  const parts = sku.split(":");
  const webinarIds = parts[0] ? parts[0].split("|") : [];
  const durations = parts[1] ? parts[1].split("|") : [];
  if (!webinarIds[0] || !durations[0]) return;
  const firstWebinarId = webinarIds[0].replace(/^omrdd_/, "");
  const firstWebinarPair = "omrdd_" + firstWebinarId + ":" + durations[0];

  const subheadline = "Erhalte gratis Zugang zur ersten Session: " + firstSessionHeadline + " am " + firstSessionDate + " um " + firstSessionTime + ". Binnen weniger Sekunden landet ein Kalendereintrag mit deinem Zugangslink in deinem E-Mail-Postfach.";

    const firstSessionFormModifier = "firstSessionModalForm";


    const firstSessionFormFields = [
    {
        "fields": [
            {
                "row": [
                    {
                        "type": "text",
                        "urlparamname": "firstname",
                        "label": "Vorname",
                        "placeholder": "Dein Vorname",
                        "error": "Bitte trage deinen Vornamen ein",
                        "required":"true"
                    },
                    {
                        "type": "email",
                        "urlparamname": "email",
                        "label": "E-Mail",
                        "placeholder": "Deine E-Mail",
                        "error": "Bitte trage deine E-Mail ein",
                        "required":"true"
                    }
                ]
            }
          ,{
                "row": [
                    {
                        "type": "math",
                        "label": "Validierung",
                        "urlparamname": "math",
                        "placeholder": "Bitte löse diese Matheaufgabe",
                        "error": "Bitte zeige uns, dass du kein Bot bist und löse diese Matheaufgabe",
                        "required":"true"
                    }
                ]
            }
        ],
        "headlines": {"headline": "Jetzt eintragen", "subheadline": subheadline},
        "agb": {"text": "Mit dem Absenden stimmst du unserer Datenschutzerklärung zu."},
        "button": {"text": "Absenden"},
        "success": {"icon": "✔️", "message":"Super, das hat geklappt! Solltest du noch kein Subscriber sein, bestätige bitte die E-Mail, die wir dir gerade an deine E-Mail Adresse geschickt haben.<br><br>Schau am besten auch in deinen Spam-Ordner.","filedownoad":"","buttontext":"","url":""},
        "tracking":{"webhook":"https://hooks.zapier.com/hooks/catch/590116/3wrzncq/","additionalparams":[

          
                {
                    "key": "list",
                    "value":"OMR_Education"
                },
                {
                    "key": "utm_content",
                    "value":"firstsession-form"
                },
                {
                    "key": "doimessage",
                    "value":"Die Anmeldung zum kostenlosen Online-Seminar war erfolgreich! Der Kalendereintrag mit deinem persönlichen Zugangslink ist auch schon auf dem Weg zu dir. Damit wir dir nach dem Online-Seminar die Aufzeichnung und die Slides zusenden können, bestätige bitte über den Button die Anmeldung zum OMR Education Newsletter."
                },
                {
                    "key": "webinarid",
                    "value": firstWebinarPair
                }

            ]},
        "background":{
            "desktopleft":"",
            "desktopright":"",
            "laptopleft":"",
            "laptopright":"",
            "tabletleft":"",
            "tabletright":"",
            "mobileleft":"",
            "mobileright":"",

        },
        "color":""
    }
];



if (typeof openModal === 'function') {
  openModal('createForm', 'contactform-wrapper', 'contactform-wrapper-demoCampusModalForm', firstSessionFormModifier, firstSessionFormFields);
}




  
  }


  // ---------------------------------------------------------------
  // Responsive class-swap (D8 — preserved for now)
  // ---------------------------------------------------------------

  function updateResponsiveTNForm() {
    // Im PDP-Hero liegt die Box IM FLOW (position: static, scrollt mit) –
    // die Fixed-Positionierung (style.left/top) und der Kompakt-Modus für
    // niedrige Viewports (inkl. display:none auf der Headline) sind dort
    // weder nötig noch erwünscht. Gilt weiterhin für die alte fixed Box
    // (page.ravi-test-sections).
    if (document.querySelector('.pdp-hero #TN-Form-Dialog')) return;

    const screenWidth = window.innerWidth;

    if (screenWidth >= 320 && screenWidth <= 767) {
      const pdpTnFormHeadline = document.querySelector('.TN-Form-Headline-Wrapper > h4');
      if (pdpTnFormHeadline) {
        pdpTnFormHeadline.classList.remove('text-headline-m-desktop');
        pdpTnFormHeadline.classList.add('text-headline-m-mobile');
      }
    }

    if (screenWidth >= 768 && screenWidth <= 1023) {
      const pdpTnFormHeadline = document.querySelector('.TN-Form-Headline-Wrapper > h4');
      if (pdpTnFormHeadline) {
        pdpTnFormHeadline.classList.remove('text-headline-m-desktop');
        pdpTnFormHeadline.classList.add('text-headline-m-mobile');
      }
    }

    if (screenWidth >= 1024 && screenWidth <= 1439) {
      const pdpTnFormContainer = document.getElementById('TN-Form-Dialog');
      const positionLeft = (window.innerWidth - 1024) / 2 + 553 + 32 + 16;
      if (pdpTnFormContainer) {
        pdpTnFormContainer.style.left = positionLeft + 'px';
      }

      const pdpTnFormHeadline = document.querySelector('.TN-Form-Headline-Wrapper > h4');
      if (pdpTnFormHeadline) {
        pdpTnFormHeadline.classList.remove('text-headline-m-mobile');
        pdpTnFormHeadline.classList.add('text-headline-m-desktop');
      }

      if (window.innerHeight <= 780 && pdpTnFormContainer) {
        pdpTnFormContainer.style.top = 32 + 150 + 'px';
        pdpTnFormContainer.style.zIndex = 1200;

        const pdpTnFormHeadlineWrapper = document.querySelector('.TN-Form-Headline-Wrapper');
        if (pdpTnFormHeadlineWrapper) {
          pdpTnFormHeadlineWrapper.style.display = 'none';
        }

        const pdpTnFormTopCta = document.querySelector('.TN-Form-CTA-Top');
        if (pdpTnFormTopCta) {
          pdpTnFormTopCta.style.gap = 8 + 'px';
        }

        const pdpTnFormContent = document.querySelector('.TN-Form-Content');
        if (pdpTnFormContent) {
          pdpTnFormContent.style.padding = 24 + 'px';
          pdpTnFormContent.style.gap = 16 + 'px';
        }

        const pdpTnFormCtaWrapper = document.querySelector('.TN-Form-CTA-Wrapper');
        if (pdpTnFormCtaWrapper) {
          pdpTnFormCtaWrapper.style.gap = 16 + 'px';
        }
        const pdpTnFormPriceWrapper = document.querySelector('.TN-Form-Price-Wrapper');
        if (pdpTnFormPriceWrapper) {
          pdpTnFormPriceWrapper.style.gap = 8 + 'px';
        }
      }
    }

    if (screenWidth >= 1439) {
      const pdpTnFormContainer = document.getElementById('TN-Form-Dialog');
      const positionLeft = (window.innerWidth - 1440) / 2 + 648 + 172 + 24;
      if (pdpTnFormContainer) {
        pdpTnFormContainer.style.left = positionLeft + 'px';
      }

      const pdpTnFormHeadline = document.querySelector('.TN-Form-Headline-Wrapper > h4');
      if (pdpTnFormHeadline) {
        pdpTnFormHeadline.classList.remove('text-headline-m-mobile');
        pdpTnFormHeadline.classList.add('text-headline-m-desktop');
      }

      if (window.innerHeight <= 780 && pdpTnFormContainer) {
        pdpTnFormContainer.style.top = 32 + 150 + 'px';
        pdpTnFormContainer.style.zIndex = 1200;

        const pdpTnFormHeadlineWrapper = document.querySelector('.TN-Form-Headline-Wrapper');
        if (pdpTnFormHeadlineWrapper) {
          pdpTnFormHeadlineWrapper.style.display = 'none';
        }

        const pdpTnFormTopCta = document.querySelector('.TN-Form-CTA-Top');
        if (pdpTnFormTopCta) {
          pdpTnFormTopCta.style.gap = 8 + 'px';
        }

        const pdpTnFormContent = document.querySelector('.TN-Form-Content');
        if (pdpTnFormContent) {
          pdpTnFormContent.style.padding = 24 + 'px';
          pdpTnFormContent.style.gap = 16 + 'px';
        }

        const pdpTnFormCtaWrapper = document.querySelector('.TN-Form-CTA-Wrapper');
        if (pdpTnFormCtaWrapper) {
          pdpTnFormCtaWrapper.style.gap = 16 + 'px';
        }

        const pdpTnFormPriceWrapper = document.querySelector('.TN-Form-Price-Wrapper');
        if (pdpTnFormPriceWrapper) {
          pdpTnFormPriceWrapper.style.gap = 8 + 'px';
        }
      }
    }
  }

  updateResponsiveTNForm();
  window.addEventListener('resize', updateResponsiveTNForm);
})();
